import type { FC } from 'react';

import Password from '../../../../components/fields/password/password';
import {
  type FieldWrapperProps,
  FormContextConsumer,
} from '../../form_context/form_context';
import formField, { pickProps } from '../../form_field/form_field';

const componentProps = [
  'show',
  'type',
  'placeholder',
  'autoFocus',
  'inputMode',
] as const;

const Field = formField(Password, {
  defaultValue: '',
  transformProps: (props) => pickProps(props, componentProps),
});

export type PasswordFieldWrapperProps = FieldWrapperProps<typeof Field>;

const PasswordFieldWrapper: FC<PasswordFieldWrapperProps> = (props) => (
  <FormContextConsumer>
    {(context) => <Field {...props} {...context} />}
  </FormContextConsumer>
);

export default PasswordFieldWrapper;
